enum ProductTypeEnum {
  Variable = 'VARIABLE',
  Grouped = 'GROUPED',
  Donation = 'DONATION',
  Voucher = 'VOUCHER'
}

export { ProductTypeEnum }
